class AuthService {
    logout() {
        localStorage.removeItem('tokenJWT');
        localStorage.removeItem('expiration');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('scope');
        localStorage.removeItem('tokenType');
        localStorage.removeItem('comptage');
        localStorage.removeItem('naf');
        localStorage.removeItem('juridique');
        // location.replace('https://auth.stg.infolegale.fr/logout?response_type=code&state=&client_id=' + process.env.VUE_APP_CLIENT_ID + '&scope=openid&redirect_uri=' + process.env.VUE_APP_REDIRECT_URI);
        location.replace(process.env.VUE_APP_AUTH_URI + '/logout?redirect_uri=' + process.env.VUE_APP_REDIRECT_URI);
    }

}

export default new AuthService();
